















































import { defineComponent, inject } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import { useUiHelpers, useUiState } from '~/composables';
import GridListToggle from '~/modules/catalog/category/components/views/GridListToggle.vue';
import ToggleFilters from '~/modules/catalog/category/components/navbar/ToggleFilters.vue';
import SelectedFilters from '~/modules/catalog/category/components/filters/FiltersSidebar/SelectedFilters.vue';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  components: {
    SfButton,
    SvgImage,
    GridListToggle,
    ToggleFilters,
    SelectedFilters,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const {
      toggleFilterSidebar, changeToCategoryListView, changeToCategoryGridView, isCategoryGridView, isFilterSidebarOpen,
      toggleDesktopFilters, isDesktopFiltersOpen,
    } = useUiState();
    const uiHelpers = useUiHelpers();
    const {
      removableFilters, doRemoveFilter, doClearFilters,
    }: any = inject('UseFiltersProvider');
    const doChangeSorting = (sort: string) => {
      uiHelpers.changeSorting(sort, false);
      emit('reloadProducts');
    };
    return {
      toggleFilterSidebar,
      toggleDesktopFilters,
      isDesktopFiltersOpen,
      doChangeSorting,
      ...uiHelpers,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      isFilterSidebarOpen,
      removableFilters,
      doRemoveFilter,
      doClearFilters,
    };
  },
});
